import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

function Button(props) {
	const navigate = useNavigate();

	const buttonClass = (() => {
		switch (props.buttonStyle) {
			case "primary":
				return "bg-steerBlack text-steerBg";
			case "secondary":
				return "bg-steerOrange text-white";
			case "checkout":
				return "bg-green-500 hover:bg-green-600 text-white";
			default:
				return "";
		}
	})();

	const handleClick = async () => {
		if (props.onClick) {
			try {
				await props.onClick();
				if (props.buttonLink) {
					handleNavigation(props.buttonLink);
				}
			} catch (error) {
				console.error(error); // Log the error to the console
			}
		} else if (props.buttonLink) {
			handleNavigation(props.buttonLink);
		}
	};

	const handleNavigation = (link) => {
		// Check if it's a hash link (anchor link)
		if (link.startsWith("/#")) {
			const targetId = link.substring(2); // Remove "/#" to get the ID
			const targetElement = document.getElementById(targetId);
			if (targetElement) {
				targetElement.scrollIntoView({
					behavior: "smooth",
					block: "start",
				});
			}
		} else {
			// Regular navigation for other links
			navigate(link);
		}
	};

	return (
		<button
			disabled={props.disabled}
			className={`flex w-fit font-generalSans rounded-2xl px-6 text-sm font-medium transition-all hover:scale-105 text-[#FAF8ED] duration-300 ease-out py-2 ${buttonClass} ${
				props.disabled ? "opacity-50 cursor-not-allowed" : ""
			}`}
			onClick={handleClick}
		>
			{typeof props.buttonName === "string"
				? props.buttonName.toUpperCase()
				: props.buttonName}{" "}
		</button>
	);
}

Button.propTypes = {
	buttonName: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
		.isRequired,
	buttonLink: PropTypes.string,
	disabled: PropTypes.bool,
	onClick: PropTypes.func,
	buttonStyle: PropTypes.oneOf(["primary", "secondary", "checkout"]),
};

export default Button;
